import {api, getCompetition} from 'app/services/api';
import {changeHeaderText} from 'app/actions/headerActions';
import {catchDataError, checkApiRedirect, RedirectException} from 'app/helpers/apiHelpers';
import {updateHistory} from 'app/actions/historyActions';
import {updateHttpError} from 'app/components/error/ErrorHandlerActions';

const getCompetitionAlltime = competitionSlug => {
  return api.get(`/standings?competition=${competitionSlug}&season=all`);
};

function updateLeague(data) {
  return {
    type: 'LEAGUE_ALLTIME_META_LEAGUE_UPDATE',
    data,
  };
}

function updateAlltime(data) {
  return {
    type: 'LEAGUE_ALLTIME_UPDATE',
    data,
  };
}

function fetchingAlltime() {
  return {
    type: `LEAGUE_ALLTIME_FETCHING`,
  };
}

function setLeagueHeader(dispatch, league) {
  const parent = {
    name: league.name,
    entity: 'league',
    slugs: {
      leagueSlug: league.slug,
    },
  };

  dispatch(
    changeHeaderText({
      title: 'Ewige Tabelle',
      parent,
    })
  );
}

function fetchLeagueAlltime(leagueSlug, dispatchRedux) {
  return function (dispatch, state) {
    if (state.league && state.teams.length) {
      setLeagueHeader(dispatchRedux, state.league);
      return;
    }
    if (state.error) {
      return;
    }
    const response1 = getCompetition(leagueSlug).then(response => {
      const league = response.data;
      checkApiRedirect(league.slug, leagueSlug, null, null, null);
      dispatch(updateLeague(league));
      setLeagueHeader(dispatchRedux, league);
    });
    dispatch(fetchingAlltime());
    const response2 = getCompetitionAlltime(leagueSlug).then(response => {
      dispatch(updateAlltime(response.data));
    });
    return Promise.all([response1, response2]).catch(error => {
      if (error instanceof RedirectException) {
        throw error;
      } else {
        const errorData = catchDataError(error);
        dispatchRedux(updateHttpError(errorData));
      }
    });
  };
}

function fetchLeagueAlltimeSSR(leagueSlug) {
  return async function (dispatch, getState) {
    const response1 = getCompetition(leagueSlug).then(response => {
      const league = response.data;
      checkApiRedirect(league.slug, leagueSlug, null, null, getState);
      dispatch(updateHistory('undefined', {store: 'LeagueAlltimePage', data: {league: response.data}}));
      setLeagueHeader(dispatch, league);
    });
    const response2 = getCompetitionAlltime(leagueSlug).then(response => {
      dispatch(
        updateHistory('undefined', {
          store: 'LeagueAlltimePage',
          data: {teams: response.data, isFetching: false},
        })
      );
    });
    try {
      return await Promise.all([response1, response2]);
    } catch (error) {
      if (error instanceof RedirectException) {
        throw error;
      } else {
        const errorData = catchDataError(error);
        dispatch(updateHttpError(errorData));
      }
    }
  };
}

export {fetchLeagueAlltime, fetchLeagueAlltimeSSR};
